/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(categoryId) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetAllIrregularityLookups: {
        $xmlns: 'http://dobs.pa.gov/dp/lookup/bpm/1.0'
      }
    },
    blueprintArrays: [
      'GetIrregularityLookupResponse.DP_LU_IrregularitiesCategory',
      'GetIrregularityLookupResponse.DP_LU_IrregularitiesSubCategory'
    ],
    blueprint: {
      categoryList: [
        '$..DP_LU_IrregularitiesCategory',
        {
          categoryId: '$..ID',
          category: '$..Category'
        }
      ],
      subcategoryList: [
        '$..DP_LU_IrregularitiesSubCategory',
        {
          subcategoryId: '$..ID',
          subcategory: '$..SubCategory',
          entityCategory: '$..CategoryID'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      response.subcategoryList = _.where(response.subcategoryList, { entityCategory: categoryId });
      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
